<script lang="ts">
    import { Col } from "sveltestrap";
    import { RatedHoverRating } from "../../../utils/Constant/Constant";
    import Card from "../../Core/Card.svelte";
    import {Rating} from 'svelte-stars-hover-rating';
    let rate:number=3
</script>
<Col md="6">
    <Card cardHeaderprops="pb-0" headerTitle={RatedHoverRating}>
      <div slot="contentbody">
        <Rating bind:rating={rate} num = 5 />
        <span>Your Rated : {rate}</span>
      </div>
    </Card>
</Col>